import { faHandHoldingDollar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "@inertiajs/react";

const SECTION_LINKS_LIMIT = 10;

export default function FooterSection({
  referencesSections,
  topRibbon
}: any) {
  return (
    <footer className="footer sm:footer-horizontal bg-base-200 text-base-content p-10">
      <div>
        <Link href="/">
          <img
            src="/logo.png"
            style={{
              height: '60px',
            }}
          />
        </Link>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '2px',
        }}>
          <p>Monastère et Paroisse St. Antoine - Outremont</p>
          {topRibbon.address && <p>{topRibbon.address}</p>}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '8px'
          }}>
            {topRibbon.phone && <p>{topRibbon.phone}</p>}
            {topRibbon.phone && topRibbon.email && <p>|</p>}
            {topRibbon.email && <p>{topRibbon.email}</p>}
          </div>
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '4px',
        }}>
          {/* <button className="btn btn-primary">
            Contact Us
            <FontAwesomeIcon icon={faComments} />
          </button> */}
          {/* <button className="btn btn-info">
            Donate
            <FontAwesomeIcon icon={faHandHoldingDollar} />
          </button> */}
        </div>
      </div>

      {referencesSections && referencesSections.map((section: any) => {
        const references = section.references || [];
        const hasMoreItems = references.length > SECTION_LINKS_LIMIT;

        return (
          <nav key={section.id}>
            <h6 className="footer-title">{section.title}</h6>
            {references.slice(0, SECTION_LINKS_LIMIT).map((reference: any) => (
              <Link
                key={reference.id}
                href={reference.path}
                className="link link-hover"
              >
                {reference.title}
              </Link>
            ))}
            {hasMoreItems && (
              <Link
                href={`/references/${section.id}`}
                className="link link-hover font-semibold"
              >
                View more
              </Link>
            )}
          </nav>
        );
      })}
    </footer>
  )
}
